import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import MemberSidebar from "../inc/MemberSidebar";
import {confirmAlert} from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import MD5 from "crypto-js/md5";
import iconDelete from "../img/icons/icon-trash.svg";
import ProposalProperty from './ProposalProperty'

export default function ProposalInfo(prop) {
    let navigate = useNavigate();
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let proposalId = decode.proposalId;
    let isReadOnly = decode.readOnly;

    let member = prop.member;
    let [detail, setDetail] = React.useState(null);
    let [propertyId, setPropertyId] = React.useState(1);
    let [readOnly, setReadOnly] = React.useState(false);

    let [fileList, setFileList] = React.useState([{
        id: null,
        title: null,
        file: null,
        base64: null,
        delete : false
    }]);
    let [currentFileIndex, setCurrentFileIndex] = React.useState(null);
    let refFile = React.useRef();

    //Info
    let refConclusion = React.useRef();
    let refPrinciple = React.useRef();
    let refObjective = React.useRef();
    let refFramework = React.useRef();
    let refConcept = React.useRef();
    let refMethodology = React.useRef();

    React.useEffect(() => {
        window.scrollTo(0, 0);

        (async function() {
            try {
                const resDetail = await getDetail();
                if(resDetail) {
                    setDetail(resDetail);

                    if ([Utils.PROPOSAL_STATUS_APPROVE].includes(resDetail.status)) {
                        setReadOnly(true);
                    }

                    if(isReadOnly) {
                        setReadOnly(isReadOnly);
                    }

                    if (prop !== null && prop.lang === 'en') {
                        resDetail.title = resDetail.title_en;
                    }
                }

                const resData = await getData();
                if(resData) {
                    refConclusion.current.value = resData.conclusion;
                    refPrinciple.current.value = resData.principle;
                    refObjective.current.value = resData.objective;
                    refFramework.current.value = resData.framework;
                    refConcept.current.value = resData.concept;
                    refMethodology.current.value = resData.methodology;
                    setPropertyId(resData.property);

                    if(resData.proposalInfoFile) {
                        let fileArr = [];
                        for(let rs of resData.proposalInfoFile) {
                            fileArr.push({
                                id: rs.id,
                                title: rs.title,
                                file: rs.file,
                                base64: null
                            });
                        }
                        setFileList(fileArr);
                    }
                }

                document.title = 'ทุนวิจัย Scholarship | NCSA - ' + resDetail.title;
            } catch (e) {
                //
            }
        })();
    }, []);

    React.useEffect(() => {
        // --
    }, [fileList]);

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'/proposal/viewProposal', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getData() {
        const response = await fetch(Config.apiUrl +'/proposalInfo/viewInfo', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                proposalId: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onCancel = () => {
        //if(readOnly) {
        //    navigate((prop.lang === 'en' ? '/en':'') + '/proposalApprove');
        //}
        //else {
        navigate((prop.lang === 'en' ? '/en':'') + '/proposal');
        //}
    };

    const onSubmit = async () => {
        let conclusion = refConclusion.current.value;
        let principle = refPrinciple.current.value;
        let objective = refObjective.current.value;
        let framework = refFramework.current.value;
        let concept = refConcept.current.value;
        let methodology = refMethodology.current.value;

        if(conclusion === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Project Proposal Summary':'กรุณาระบุ บทสรุปข้อเสนอโครงการ');
            refConclusion.current.focus();
        }
        else if(principle === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Principles and reasons':'กรุณาระบุ หลักการและเหตุผล');
            refPrinciple.current.focus();
        }
        else if(objective === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Objective':'กรุณาระบุ วัตถุประสงค์');
            refObjective.current.focus();
        }
        else if(framework === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Framework':'กรุณาระบุ กรอบการวิจัย');
            refFramework.current.focus();
        }
        else if(concept === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Research concepts, theories and hypotheses':'กรุณาระบุ แนวคิด ทฤษฎี และสมมติฐานงานวิจัย ');
            refConcept.current.focus();
        }
        else if(methodology === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Research Methodology and Research Procedures':'กรุณาระบุ ระเบียบวิธีวิจัยและวิธีการดำเนินการวิจัย');
            refMethodology.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            let param = {
                                proposalId: proposalId,
                                conclusion: conclusion.trim(),
                                principle: principle.trim(),
                                objective: objective.trim(),
                                framework: framework.trim(),
                                concept: concept.trim(),
                                methodology: methodology.trim(),
                                property: propertyId,
                                files: fileList,
                                updatedBy: -1,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            const result = await updateInfo(param);

                            if(result.status === 'success') {
                                toast.success(prop.lang === 'en' ? 'Part 2 Research project information has been recorded successfully.':'อัพเดตข้อมูลโครงการวิจัย เรียบร้อย');
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    async function updateInfo(param) {
        const response = await fetch(Config.apiUrl +'/proposalInfo/update', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    //Add file
    const handleClickFile = React.useCallback(() => refFile.current?.click(), []);
    const addNewFile = () => {
        setFileList([...fileList, {
            id: null,
            title: null,
            file: null,
            base64: null,
            delete: false
        }]);
    };
    const removeFile = (index) => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ยืนยันที่จะลบไฟล์เอกสารนี้ ?',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        let wl = [...fileList];
                        wl[index].delete = true;
                        setFileList(wl);
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {
                    }
                }
            ]
        });
    };
    const updateFileTitle = (item, index) => {
        let wl = [...fileList];
        wl[index].title = item;
        setFileList(wl);
    };
    const onSelectFile = (e, data) => {
        if(data) {
            let file_name = e.target.files[0].name;
            let ext = file_name.split('.').pop();
            let file = MD5(moment().format("YMMDDHHmmss") + '_' + currentFileIndex).toString() + '.' + ext;

            let wl = [...fileList];
            wl[currentFileIndex].title = file_name.replace('.' + ext, '');
            wl[currentFileIndex].file = file;
            wl[currentFileIndex].base64 = data;
            setFileList(wl);
        }
    };
    //end

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="proposal" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="card-body p-0 px-xxl-3">
                                <h2 className="h3 text-center">{prop.lang === 'en' ? 'Full Proposal':'ยื่นแบบฟอร์มข้อเสนอโครงการฉบับสมบูรณ์ (Full Proposal)'}</h2>
                                <div className="text-center">{prop.lang === 'en' ? 'Strategic Research Project (Strategic Fund; SF): Research Project Type':'โครงการวิจัยเชิงกลยุทธ์ (Strategic Fund; SF) : ประเภทโครงการวิจัย'}</div>
                                <h3 className="mt-2 text-center">{prop.lang === 'en' ? 'Research Fund Name ':'ชื่อทุนวิจัย '} : {prop.lang === 'en' ? detail?.scholarship.title_en : detail?.scholarship.title}</h3>

                                <h3 className="title-bar mt-4 mb-2">{prop.lang === 'en' ? 'Part 2 Research project information':'ส่วนที่ 2 ข้อมูลโครงการวิจัย'}</h3>

                                <div className="row g-4 mt-2">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>1. {prop.lang === 'en' ? 'Project Proposal Summary':'บทสรุปข้อเสนอโครงการ (ไม่เกิน 3,000 คำ)'} <span className="star">*</span></h6>
                                            <textarea className="form-control" ref={refConclusion} maxLength={3000} rows={5} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>2. {prop.lang === 'en' ? 'Principles and reasons':'หลักการและเหตุผล  (ไม่เกิน 3,000 คำ)'} <span className="star">*</span></h6>
                                            <textarea className="form-control" ref={refPrinciple} maxLength={3000} rows={5} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>3. {prop.lang === 'en' ? 'Objectives (specify in points)':'วัตถุประสงค์ (ระบุเป็นข้อ)'} <span className="star">*</span></h6>
                                            <textarea className="form-control" ref={refObjective} maxLength={3000} rows={5} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>4. {prop.lang === 'en' ? 'Framework':'กรอบการวิจัย'} <span className="star">*</span></h6>
                                            <textarea className="form-control" ref={refFramework} maxLength={3000} rows={5} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>5. {prop.lang === 'en' ? 'Research concepts, theories and hypotheses':'แนวคิด ทฤษฎี และสมมติฐานงานวิจัย (ไม่เกิน 3000 คำ)'} <span className="star">*</span></h6>
                                            <textarea className="form-control" ref={refConcept} maxLength={3000} rows={5} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>6. {prop.lang === 'en' ? 'Research methodology and research implementation methods':'ระเบียบวิธีวิจัยและวิธีการดำเนินการวิจัย'} <span className="star">*</span></h6>
                                            <textarea className="form-control" ref={refMethodology} maxLength={3000} rows={5} disabled={readOnly} />
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="d-flex justify-content-between gap-3">
                                            <h6 className="pt-1">7. {prop.lang === 'en' ? 'Academic reference documents/research on the project':'เอกสาร/งานวิจัยอ้างอิงทางวิชาการเกี่ยวกับโครงการ'}</h6>
                                            {
                                                readOnly ? '' : <button className="btn btn-xs btn-light-2" onClick={addNewFile}>
                                                    {prop.lang === 'en' ? '+ Add File':'+ เพิ่มไฟล์'}
                                                </button>
                                            }
                                        </div>
                                        <div className="table-responsive mt-3">
                                            <table className="table table-info table-hover text-center">
                                                <thead>
                                                <tr>
                                                    <th className="text-start">{prop.lang === 'en' ? 'Document Name':'ชื่อเอกสาร'}</th>
                                                    {
                                                        readOnly ? <th className="text-center" style={{width:'100px'}}>{prop.lang === 'en' ? 'Download':'ดาวน์โหลด'}</th> : <th className="text-center" style={{width:'100px'}}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</th>
                                                    }
                                                    {
                                                        readOnly ? '' : <th className="text-center" style={{width:'100px'}}></th>
                                                    }
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    fileList.length > 0 ?
                                                        fileList.map((row, index) => {
                                                            return (
                                                                row.delete ? '' :
                                                                    <tr key={index}>
                                                                        <td>
                                                                            <input type="text" className="form-control" onChange={e => updateFileTitle(e.target.value, index)} value={row.title ?? ''} disabled={readOnly}  />
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                row.id ? <NavLink className="input-group-text btn btn-sm btn-light" target="_blank" to={Config.fileUpload + 'proposal_info_file/' + row.file}>{prop.lang === 'en' ? 'Download':'ดาวน์โหลด'}</NavLink> : <button type="button" className="input-group-text btn btn-sm btn-light" onClick={() => {
                                                                                    handleClickFile();
                                                                                    setCurrentFileIndex(index);
                                                                                }}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</button>
                                                                            }
                                                                        </td>
                                                                        {
                                                                            readOnly ? '' : <td>
                                                                                {
                                                                                    index > 0 ? <button className="btn btn-trans mx-auto" onClick={() => removeFile(index)}><img className="icons svg-js trash" src={iconDelete} alt="" /></button> : ''
                                                                                }
                                                                            </td>
                                                                        }
                                                                    </tr>
                                                            )
                                                        }) : ''
                                                }
                                                </tbody>
                                            </table>

                                            <input type="file" className="form-control d-none" ref={refFile} onChange={(e) => {
                                                Utils.onSelectFile(e).then(
                                                    data => onSelectFile(e, data)
                                                );
                                            }} accept={Utils.allowFileExtension} />
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>8. {prop.lang === 'en' ? 'Related intellectual property investigations':'การตรวจสอบทรัพย์สินทางปัญญาที่เกี่ยวข้อง'} <span className="star">*</span></h6>
                                            <div className="row ps-3">
                                                <div className="col-md-12">
                                                    <div className="form-check lg">
                                                        <input className="form-check-input" type="radio" value="" id="projectTypeId1" name="projectTypeId1" onChange={e => setPropertyId(Utils.PROPERTY_CHECK_NOCHECK)} checked={Utils.PROPERTY_CHECK_NOCHECK === propertyId} disabled={readOnly} />
                                                        <label className="form-check-label" htmlFor="projectTypeId1">{prop.lang === 'en' ? 'There is no examination of the relevant intellectual property and/or patents':'ไม่มีการตรวจสอบทรัพย์สินทางปัญญา และ/หรือ สิทธิบัตรที่เกี่ยวข้อง'}</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mt-2">
                                                    <div className="form-check lg">
                                                        <input className="form-check-input" type="radio" value="" id="projectTypeId2" name="projectTypeId2" onChange={e => setPropertyId(Utils.PROPERTY_CHECK_NOTFOUND)} checked={Utils.PROPERTY_CHECK_NOTFOUND === propertyId} disabled={readOnly} />
                                                        <label className="form-check-label" htmlFor="projectTypeId2">{prop.lang === 'en' ? 'Intellectual property check found no related intellectual property and/or patents':'ตรวจสอบทรัพย์สินทางปัญญาแล้ว ไม่มีทรัพย์สินทางปัญญา และ/หรือ สิทธิบัตรที่เกี่ยวข้อง'}</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mt-2">
                                                    <div className="form-check lg">
                                                        <input className="form-check-input" type="radio" value="" id="projectTypeId2" name="projectTypeId2" onChange={e => setPropertyId(Utils.PROPERTY_CHECK_FOUND)} checked={Utils.PROPERTY_CHECK_FOUND === propertyId} disabled={readOnly} />
                                                        <label className="form-check-label" htmlFor="projectTypeId2">{prop.lang === 'en' ? 'Intellectual property has been checked and there are related intellectual property and/or patents':'ตรวจสอบทรัพย์สินทางปัญญาแล้ว มีทรัพย์สินทางปัญญา และ/หรือ สิทธิบัตรที่เกี่ยวข้อง'}</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <ProposalProperty proposalId={proposalId} member={member} readOnly={readOnly} />
                                        </div>
                                    </div>
                                </div>

                                <div className="py-3"><hr /></div>
                                <div className="buttons gap-15 py-0 mb-4">
                                    <button className="btn btn-gray w-130" type="button" onClick={onCancel}>{prop.lang === 'en' ? 'Prev':'ย้อนกลับ'}</button>
                                    {
                                        !readOnly ? <button className="btn btn-secondary w-130" type="button" onClick={onSubmit}>{prop.lang === 'en' ? 'Save':'บันทึกข้อมูล'}</button> : ''
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 